import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import SwiperCustom from '../../../../components/swiper/SwiperCustom'
import { Box, Typography } from '@mui/material'

type Props = {
    files: any[];
    equipment: { equipment_name: string, qty: string, equipment_unit: string }[];
}

const ItemsInClassrooms: React.FC<Props> = ({ files, equipment }: Props) => {
    const base_url_image = useSelector((state: RootState) => state.api.image_api);
    
    return (
        <div className='w-full'>
            <SwiperCustom
                data={files?.map((list: any) => {
                    const img_path = base_url_image + list?.file_path;
                    return {
                        content: (
                            <Box className="w-full">
                                <img
                                    src={img_path}
                                    alt={list?.file_name}
                                />
                            </Box>
                        )
                    }
                })}
            />
            <Box my={2}>
                <Typography variant='h6'>อุปกรณ์ภายในห้อง</Typography>
                <ul className="list-disc pl-6 pt-4">
                    {equipment?.length > 0 &&
                        equipment.map((list: any, i: number) => (
                            <li key={i + 1}>
                                {`${list?.equipment_name || ""} ${list?.qty || ""} ${list?.equipment_unit || ""}`}
                            </li>
                        ))}
                </ul>
            </Box>
        </div>
    )
}

export default ItemsInClassrooms